import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { COLORS } from './orderManagementConfig';

export function OrderManagementComingSoonPlaceholder({ title, description, Icon }) {
  return (
    <Box
      sx={{
        py: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '18px',
          bgcolor: '#F7F8FA',
          border: `1.5px solid ${COLORS.border}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 0.5,
        }}
      >
        <Icon sx={{ fontSize: 30, color: COLORS.muted }} />
      </Box>
      <Typography
        sx={{
          fontFamily: 'Inter Bold, sans-serif',
          fontSize: 17,
          fontWeight: 700,
          color: COLORS.ink,
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Inter Regular, sans-serif',
          fontSize: 13.5,
          color: COLORS.muted,
          textAlign: 'center',
          maxWidth: 360,
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}
